// Tiroir panier Sereine : affichage du panier sans changer de page.
// Une seule offre par commande (le fournisseur n'expédie qu'un article).
(function () {
  var d = document.querySelector('[data-sr-drawer]');
  if (!d || window.SereineDrawer) return;
  var base = d.dataset.root || '/';
  if (base.slice(-1) !== '/') base += '/';
  var t = parseInt(d.dataset.threshold, 10);
  var threshold = isNaN(t) ? 4000 : t; // 0 = livraison offerte sur tout
  var soloPrice = parseInt(d.dataset.soloPrice, 10) || 0;
  var tiers = [];
  try { tiers = JSON.parse(d.dataset.tiers || '[]'); } catch (err) {}
  var nextId = null;
  var panel = d.querySelector('.sr-drawer__panel');
  var $ = function (s) { return d.querySelector(s); };
  var lastFocus = null;

  var euro = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  var esc = function (s) { var e = document.createElement('div'); e.textContent = s == null ? '' : String(s); return e.innerHTML; };
  var json = function (r) { if (!r.ok) throw r; return r.json(); };
  var getCart = function () { return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(json); };
  var setOnly = function (cart, id) {
    var updates = {};
    cart.items.forEach(function (i) { updates[i.variant_id] = 0; });
    if (id) updates[id] = 1;
    return fetch(base + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(json);
  };


  // Avis : seulement ceux déjà publiés sur la page (section « Avis clientes »)
  var reviews = document.querySelectorAll('.sr-reviews .sr-review');
  if (reviews.length) {
    var list = $('[data-reviews-list]');
    Array.prototype.slice.call(reviews, 0, 2).forEach(function (r) {
      var c = r.cloneNode(true);
      c.removeAttribute('data-shopify-editor-block');
      list.appendChild(c);
    });
    $('[data-reviews]').hidden = false;
  }

  var render = function (cart) {
    var total = cart.total_price;
    var items = $('[data-items]');
    items.innerHTML = cart.items.map(function (i) {
      var img = i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      return '<li class="sr-drawer__item">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="64" height="80" loading="lazy">' : '<span></span>') +
        '<div><p class="sr-drawer__it-t">' + esc(i.product_title) + '</p>' +
        '<p class="sr-drawer__it-v">' + esc(i.variant_title || '') + '</p>' +
        '<button type="button" class="sr-drawer__rm" data-remove>Retirer</button></div>' +
        '<b>' + euro(i.final_line_price) + '</b></li>';
    }).join('');
    var empty = cart.item_count === 0;
    $('[data-empty]').hidden = !empty;
    $('[data-total]').textContent = euro(total);
    $('[data-checkout]').disabled = empty || cart.item_count > 1;

    var free = threshold === 0 || total >= threshold;
    $('[data-ship-text]').innerHTML = threshold === 0 ? '<b>Livraison suivie offerte</b> sur toutes les offres.'
      : empty ? 'Livraison offerte dès ' + euro(threshold) + '.'
      : free ? '<b>Livraison offerte</b> sur ta commande.'
      : 'Plus que <b>' + euro(threshold - total) + '</b> pour la livraison offerte.';
    $('.sr-drawer__bar').hidden = threshold === 0;
    if (threshold) $('[data-ship-bar]').style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
    $('[data-ship-foot]').textContent = free ? 'Livraison suivie offerte.' : 'Frais de livraison calculés au paiement.';

    // Offre suivante : celle juste au-dessus de l'offre du panier
    nextId = null;
    var cur = cart.item_count === 1 ? cart.items[0].variant_id : null;
    var k = -1;
    tiers.forEach(function (x, j) { if (x.id === cur) k = j; });
    var next = k > -1 ? tiers[k + 1] : null;
    if (next && next.available) {
      nextId = next.id;
      // Girls Night : économie réelle par sticker face à l'offre Découverte (prix actuels)
      var soloN = (tiers[0] && tiers[0].stickers) || 10;
      var soloPer = Math.round(soloPrice / soloN);
      var nextPer = Math.round(next.price / next.stickers);
      var pct = soloPer ? Math.round(100 - nextPer * 100 / soloPer) : 0;
      $('[data-upsell-title]').textContent = 'Girls Night · Passe au ' + next.name;
      $('[data-upsell-desc]').innerHTML = next.stickers + ' stickers, ' +
        (pct > 0 ? '<b>−' + pct + ' %</b> par sticker : ' + euro(nextPer) + ' au lieu de ' + euro(soloPer) + ' en Découverte.' : euro(nextPer) + ' le sticker.');
      $('[data-upsell-btn]').textContent = 'Passer au ' + next.name + ' · ' + euro(next.price);
    }
    $('[data-upsell]').hidden = !nextId;
  };

  var busy = function (on) { panel.classList.toggle('is-busy', on); };
  var refresh = function () { return getCart().then(render); };

  var close = function () {
    d.classList.remove('is-open');
    document.documentElement.classList.remove('sr-lock');
    setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  var open = function (opts) {
    opts = opts || {};
    lastFocus = document.activeElement;
    $('[data-replaced]').hidden = !opts.replaced;
    d.hidden = false;
    document.documentElement.classList.add('sr-lock');
    requestAnimationFrame(function () { d.classList.add('is-open'); panel.focus(); });
    busy(true);
    return refresh().catch(function () { window.location.href = base + 'cart'; }).then(function () { busy(false); });
  };

  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]')) return close();
    if (e.target.closest('[data-remove]')) {
      busy(true);
      getCart().then(function (c) { return setOnly(c, null); }).then(render).then(function () { busy(false); });
    }
    if (e.target.closest('[data-upsell-btn]')) {
      busy(true);
      getCart().then(function (c) { return setOnly(c, nextId); }).then(render).then(function () { busy(false); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (!d.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('button:not([disabled]), a[href]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  window.SereineDrawer = { open: open, close: close };
})();
